export const routeEnum = {
  PLAYERS_PERFORMANCE: 'players-performance',
  TEAM_PERFORMANCE: '/team-performance',
  UPCOMING_MATCHES: '/upcoming-matches',
  TEAM_SETUP: '/team-setup',
  SCORECARD: '/scorecard',
};
